import WidgetsShop from './component'

export default WidgetsShop
